module.exports = (__parcel__import__("krBGU")).then(() => parcelRequire('lmhgI'));